<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="4"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="4" defaultSel="2"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">

                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部订单" name="first"></el-tab-pane>
                    <el-tab-pane label="投诉处理" name="second"></el-tab-pane>
                </el-tabs>

                <div class="goods_head">
                    <div class="head_li">
                        <p class="head_wt">商品</p>
                    </div>
                    <div class="head_li">牌价</div>
                    <div class="head_li">实付款</div>
                    <div class="head_li">买家/收件信息</div>
                    <div class="head_li">供应商</div>
                    <div class="head_li">订单状态</div>
                    <div class="head_li">投诉管理</div>
                </div>

                <div class="goods_blank" v-if="listData == ''">
                    暂无订单
                </div>

                <div class="goods_col" v-for="(item, index) in listData" :key="index">
                    <div class="col_li">
                        <div class="mdb_pic">
                            <div class="pic_img" v-if="item.commodityPhoto">
                                <img :src="JSON.parse(item.commodityPhoto)[0]">
                            </div>
                            <div class="pic_info">
                                <p class="info_tit">{{ item.commodityName }}</p>
                                <p><span>货号：</span>{{ item.commodityCode }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col_li">¥{{ item.price }}</div>
                    <div class="col_li">¥{{ item.payment }}</div>
                    <div class="col_li">
                        <p>{{ item.name }} {{ item.mobile }}</p>
                        <p>{{ item.addr }}</p>
                    </div>
                    <div class="col_li">{{ item.brand }}{{ item.merchantMobile }}</div>
                    <div class="col_li col_gray">

                        <p v-if="item.orderState == 'wait'">待发货</p>
                        <p v-if="item.orderState == 'send'">发货中</p>
                        <p v-if="item.orderState == 'receive'">已收件</p>
                        <p v-if="item.orderState == 'finish'">已完结</p>
                        <p v-if="item.orderState == 'refund'">已退货</p>
                        <p class="li_clo2" @click="openXq(item)">查看详情</p>

                        <!-- 3失败，2成功，1申请中 -->
                    </div>
                    <div class="col_li col_gray">
                        <p v-if="!item.complaintId">无投诉</p>

                        <div v-if="item.complaintId">
                            <p v-if="item.status == 1">待处理！</p>
                            <el-button v-if="item.status == 1" type="text" @click="delectQx(item)">处理</el-button>

                            <p class="li_clo2" v-if="item.status == 2">投诉成立</p>
                            <p v-if="item.status == 3">投诉不成立</p>

                            <el-popover placement="bottom" width="400" trigger="hover">
                                <div class="ts_pop">
                                    <div class="pop_li">
                                        <p class="pop_tit">客诉原因：</p>
                                        <p class="pop_text">{{item.cause}}</p>
                                    </div>
                                    <div class="pop_li">
                                        <p class="pop_tit">客诉说明：</p>
                                        <p class="pop_text" v-if="item.explain">{{item.explain}}</p>
                                    </div>
                                    <div class="pop_li">
                                        <p class="pop_tit">凭证图片：</p>
                                        <div class="pop_pic">
                                            <el-image 
                                            class="pic_img" 
                                            :src="item" 
                                            v-for="(item, index) in JSON.parse(item.commodityPhoto)" 
                                            :key="index" 
                                            fit="cover"/>
                                        </div>
                                    </div>
                                    <div class="pop_li">
                                        <p class="pop_tit">联系电话：</p>
                                        <p class="pop_text" v-if="item.complaintMobile">{{item.complaintMobile}}</p>
                                    </div>
                                </div>

                                <p slot="reference" class="li_clo2">查看</p>
                            </el-popover>
                        </div>
                    </div>
                </div>

            </el-col>
        </el-row>

        <el-dialog title="投诉处理" :visible.sync="dialog" width="30%">
            <div class="order_input1">
                <template>
                    <el-radio v-model="status" label="3">不成立</el-radio>
                    <el-radio v-model="status" label="2">投诉成立</el-radio>
                </template>
            </div>
            <!-- <div v-if="status == 2">
                <el-radio v-model="isFreeze" label="0">不冻结权限</el-radio>
                <el-radio v-model="isFreeze" label="1">冻结权限</el-radio>
            </div> -->
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确认</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>

var util = require("@/common/util.js");
import { API_DIDLIST, API_CHULITS } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,
            status: '3',  // 2成立，3不成立
            reco: '0',  // 0不推，1推荐
            isFreeze: '0', // 0不冻结，1推荐
            activeName: 'first',
            listStatus: '',

            complaintId: '',
            merchantUserId: '',
            orderId: '',
            price: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        // 1投诉，2申请，3失败
        getListData() {
            let params = new URLSearchParams();
            params.append('status', this.listStatus);
            util.getData(API_DIDLIST, params, (res) => {
                this.listData = res.data.data
            })
        },
        delectQx(e) {
            this.complaintId = e.complaintId
            this.merchantUserId = e.merchantUserId
            this.orderId = e.orderId
            this.price = e.price
            this.dialog = true
        },
        sendApi() { 
            let params = new URLSearchParams();

            params.append('complaintId', this.complaintId);
            params.append('merchantUserId', this.merchantUserId);
            params.append('orderId', this.orderId);
            params.append('price', this.price);
            params.append('status', this.status);
            // if (this.status == 2) {
            //     params.append('isFreeze', this.isFreeze);
            // }
            util.getData(API_CHULITS, params, (res) => {
                console.log(res.data)
                this.dialog = false
                this.$message('操作成功')
                this.listStatus = '1'
                this.getListData()
            })
        },
        openXq(e) {   // 查看详情
            this.$router.push({ path: '/odInfo' });
            localStorage.setItem('orderInfo', JSON.stringify(e))
        },
        handleClick(tab) {
            if(tab.name == 'first'){
                this.listStatus = ''
            }else{
                this.listStatus = '1'
            }
            this.getListData()
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}

.g-header-right {
    background-color: #5c6be8;
    color: #FFF;
    padding-right: 40px;
    height: 60px;
    line-height: 60px;
    text-align: right;
}

.g-header-right span {
    margin: 0 10px;
    cursor: pointer;
}

.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.order_input1 {
    margin-bottom: 20px;
}
.goods_head {
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    padding: 10px 0;
    border: 1px solid #ebeef5;

    .head_wt {
        width: 270px;
    }

    .head_li {
        color: #232527;
        flex: 1;
        padding-left: 14px;
    }
}
.goods_blank{
    font-size: 16px;
    border: 1px solid #ebeef5;
    line-height: 100px;
    border-radius: 4px;
    background-color: #ffffff;
    margin: 20px 0;
    text-align: center;
    color: #78858E;
}
.goods_col {
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    border: 1px solid #ebeef5;
    margin: 10px 0;
}
.col_li {
    padding: 14px;
    flex: 1;
    padding-left: 14px;
    border-right: 1px solid #ebeef5;
    .li_clo1 {
        color: #67c23a;
    }
    .li_clo2 {
        cursor: pointer;
        color: #f56c6c;
    }
}
.col_gray{
    color: rgb(152, 152, 152);
}

.mdb_pic {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 260px;

    .pic_img {
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #e7e7e7;

        img {
            width: 100%;
            height: auto;
        }
    }

    .pic_info {
        flex: 1;
        height: 80px;

        .info_tit {
            padding-bottom: 10px;
        }
    }
}
.ts_pop{
    .pop_li{
        display: flex;
        flex-direction: row;
        flex: 1;
        margin: 12px 0;
    }
    .pop_pic{
        display: flex;
        flex-direction: row;
        .pic_img{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 80px;
            height: 80px;
            background-color: #f2f2f2;
            border-radius: 10px;
            margin-right: 6px;
            margin-bottom: 6px;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/order/index.vue